// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-trail-page {
  background-color: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  width: 100%;
}

/* Page Header */
.page-header {
  margin-bottom: 30px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.page-subtitle {
  font-size: 16px;
  color: #6c757d;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6c757d;
}

.breadcrumb-item {
  color: #6c757d;
}

.breadcrumb-item.current {
  color: #495057;
  font-weight: 500;
}

.breadcrumb-separator {
  margin: 0 12px;
  color: #adb5bd;
}

/* Audit Trail Section */
.audit-trail-section {
  background: white;
  margin: 24px 0px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Table Container */
.audit-table-container {
  overflow-x: auto;
}

/* Table Styles */
.audit-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background: white;
}

.audit-table thead {
  background-color: "rgba(255, 255, 255, 0.5)";
}

.audit-table th {
  padding: 16px 20px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.audit-table td {
  padding: 20px;
  vertical-align: top;
  border-bottom: 1px solid #f1f3f4;
  color: #495057;
  line-height: 1.4;
}

.audit-table tbody tr:last-child td {
  border-bottom: none;
}

/* Specific Cell Styles */
.timestamp-cell {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 13px;
  color: #6c757d;
  white-space: nowrap;
}

.user-cell {
  color: #495057;
  font-weight: 500;
}

.action-cell {
  font-weight: 600;
  color: #2c3e50;
}

.revenue-line-cell {
  font-weight: 500;
  color: #2c3e50;
}

.field-cell {
  color: #495057;
}

.old-value-cell {
  color: #6c757d;
}

.new-value-cell {
  color: #495057;
  font-weight: 500;
}

.version-cell {
  padding: 20px;
}

.version-badge {
  background: #f8f9fa;
  color: #495057;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #dee2e6;
  white-space: nowrap;
}

.reason-cell {
  color: #495057;
  max-width: 200px;
  word-wrap: break-word;
  line-height: 1.5;
}

/* Pagination */
.audit-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-top: 1px solid #e9ecef;
  background: white;
}

.pagination-info {
  color: #6c757d;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.page-button {
  width: 36px;
  height: 36px;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.page-button:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.page-button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.page-button.active:hover {
  background: #0056b3;
  border-color: #0056b3;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .page-header {
    margin-bottom: 20px;
  }

  .audit-trail-section {
    margin: 20px 32px;
  }

  .audit-table {
    font-size: 13px;
  }

  .audit-table th,
  .audit-table td {
    padding: 12px 16px;
  }
}

@media (max-width: 768px) {
  .page-header {
    margin-bottom: 15px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .breadcrumb {
    font-size: 13px;
    flex-wrap: wrap;
  }

  .breadcrumb-separator {
    margin: 0 8px;
  }

  .audit-trail-section {
    margin: 16px 24px;
  }

  .audit-table {
    font-size: 12px;
  }

  .audit-table th,
  .audit-table td {
    padding: 10px 12px;
  }

  .reason-cell {
    max-width: 150px;
    font-size: 11px;
  }

  .audit-pagination {
    padding: 20px 24px;
    flex-direction: column;
    gap: 16px;
  }

  .pagination-controls {
    gap: 4px;
  }

  .page-button {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .page-header {
    margin-bottom: 10px;
  }

  .audit-trail-section {
    margin: 12px 20px;
  }

  .audit-table-container {
    overflow-x: scroll;
  }

  .audit-table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AuditTrail.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB;uCACqC;EACrC,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,wDAAwD;EACxD,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".audit-trail-page {\n  background-color: #f8f9fa;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  width: 100%;\n}\n\n/* Page Header */\n.page-header {\n  margin-bottom: 30px;\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin: 0 0 8px 0;\n}\n\n.page-subtitle {\n  font-size: 16px;\n  color: #6c757d;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.breadcrumb-item {\n  color: #6c757d;\n}\n\n.breadcrumb-item.current {\n  color: #495057;\n  font-weight: 500;\n}\n\n.breadcrumb-separator {\n  margin: 0 12px;\n  color: #adb5bd;\n}\n\n/* Audit Trail Section */\n.audit-trail-section {\n  background: white;\n  margin: 24px 0px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n/* Table Container */\n.audit-table-container {\n  overflow-x: auto;\n}\n\n/* Table Styles */\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  background: white;\n}\n\n.audit-table thead {\n  background-color: \"rgba(255, 255, 255, 0.5)\";\n}\n\n.audit-table th {\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 13px;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.audit-table td {\n  padding: 20px;\n  vertical-align: top;\n  border-bottom: 1px solid #f1f3f4;\n  color: #495057;\n  line-height: 1.4;\n}\n\n.audit-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Specific Cell Styles */\n.timestamp-cell {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-size: 13px;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.user-cell {\n  color: #495057;\n  font-weight: 500;\n}\n\n.action-cell {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.revenue-line-cell {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.field-cell {\n  color: #495057;\n}\n\n.old-value-cell {\n  color: #6c757d;\n}\n\n.new-value-cell {\n  color: #495057;\n  font-weight: 500;\n}\n\n.version-cell {\n  padding: 20px;\n}\n\n.version-badge {\n  background: #f8f9fa;\n  color: #495057;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.reason-cell {\n  color: #495057;\n  max-width: 200px;\n  word-wrap: break-word;\n  line-height: 1.5;\n}\n\n/* Pagination */\n.audit-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-top: 1px solid #e9ecef;\n  background: white;\n}\n\n.pagination-info {\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.page-button {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #dee2e6;\n  background: white;\n  color: #495057;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.page-button:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.page-button.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.page-button.active:hover {\n  background: #0056b3;\n  border-color: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .page-header {\n    margin-bottom: 20px;\n  }\n\n  .audit-trail-section {\n    margin: 20px 32px;\n  }\n\n  .audit-table {\n    font-size: 13px;\n  }\n\n  .audit-table th,\n  .audit-table td {\n    padding: 12px 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-header {\n    margin-bottom: 15px;\n  }\n\n  .page-title {\n    font-size: 24px;\n  }\n\n  .page-subtitle {\n    font-size: 14px;\n  }\n\n  .breadcrumb {\n    font-size: 13px;\n    flex-wrap: wrap;\n  }\n\n  .breadcrumb-separator {\n    margin: 0 8px;\n  }\n\n  .audit-trail-section {\n    margin: 16px 24px;\n  }\n\n  .audit-table {\n    font-size: 12px;\n  }\n\n  .audit-table th,\n  .audit-table td {\n    padding: 10px 12px;\n  }\n\n  .reason-cell {\n    max-width: 150px;\n    font-size: 11px;\n  }\n\n  .audit-pagination {\n    padding: 20px 24px;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .pagination-controls {\n    gap: 4px;\n  }\n\n  .page-button {\n    width: 32px;\n    height: 32px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-header {\n    margin-bottom: 10px;\n  }\n\n  .audit-trail-section {\n    margin: 12px 20px;\n  }\n\n  .audit-table-container {\n    overflow-x: scroll;\n  }\n\n  .audit-table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
